import type { ViewsProviderMeta } from '../types';

/**
 * Best Flow — contador de fluxo de visitantes por câmera.
 *
 * As credenciais vão para `credentials` (não para `config`): o
 * `GET /company-integrations` devolve o `config` inteiro ao cliente, e a senha
 * do serviço não pode trafegar ali.
 */
export const bestFlowProvider: ViewsProviderMeta = {
  id: 'views-best-flow',
  name: 'Best Flow',
  description: 'Contador de fluxo de visitantes por câmera, instalado nas portas da loja',
  icon: 'video',
  color: '#0ea5e9',
  authFields: [
    {
      name: 'endpoint',
      type: 'url',
      label: 'Endereço do serviço *',
      placeholder: 'https://www.bestflowserver.com.br/…/bestflow.php',
      required: true,
      helpText: 'A Best Flow envia este endereço junto com o login',
    },
    {
      name: 'login',
      type: 'text',
      label: 'Login *',
      placeholder: 'sua-conta.ws',
      required: true,
    },
    {
      name: 'senha',
      type: 'password',
      label: 'Senha *',
      placeholder: '',
      required: true,
    },
  ],
  configFields: ['endpoint'],
  optionFields: [
    {
      name: 'intradayEnabled',
      label: 'Mostrar o movimento de hoje',
      helpText:
        'Busca a contagem do dia de hora em hora. O número de hoje é provisório e é trocado pela contagem fechada da Best Flow na madrugada.',
    },
  ],
  isAvailable: true,
};
